import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { updateDataFreshnessPolicy } from '~src/dataFreshness/actions/UpdateDataFreshnessPolicyAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyItemIsUnpublishedWorkbook } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IEditDataFreshnessPolicyAction } from '~src/spacesPlatform/models/actionNames';
import { WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export const UpdateDataFreshnessPolicyEntityAction: IEntityAction<IContentInfo, IEditDataFreshnessPolicyAction> = {
  name: EntityActionNames.UpdateDataFreshnessPolicy,
  translateName: Messages.editDataFreshnessPolicyButtonText,
  isVisible: (targetItems: IContentInfo[], state: AppState, availableAction: IEditDataFreshnessPolicyAction) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return FeatureFlags.queryPipelineDataFreshnessUISupported &&
      targetItems && targetItems.length === 1 &&
      targetItems[0].contentType === WorkbookContentType.name &&
      availableAction && availableAction.editDataFreshnessPolicy;
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return updateDataFreshnessPolicy(targetItems);
  }
};
